import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";

import img1 from "../assets/asset_5.png";
import explore from "../assets/explore.png";
import opensea from "../assets/opensea.png";
import useWindowDimensions from "../hooks/useWindowDimensions";

const Exploring = () => {
  const { width } = useWindowDimensions();

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#explore-h", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.2,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#explore-img", {
        stagger: 0.1,
        opacity: 0,
        xPercent: -5,
      });

      tl.from("#explore-p", {
        stagger: 0.1,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#explore-btn", {
        opacity: 0,
        duration: 0.1,
        y: 50,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      style={{
        background: `url(${explore})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        ref={ref}
        id="explore"
        style={{
          height: "100%",
          textAlign: "center",
          marginTop: 75,
          marginBottom: 75,
        }}
        className="container p-5"
      >
        <div
          id="explore-h"
          style={{
            fontSize: width > 900 ? 70 : 42,
            color: "var(--primary)",
          }}
        >
          <h1 className="primary-h">
            Gutter Bats <br />
            Planet NFT - Your <br />
            Key To Exploring <br />
            Web 3.0
          </h1>
        </div>
        <p
          id="explore-p"
          className="primary-p py-3"
          style={{ textAlign: "center" }}
        >
          Web 3.0 is a wide new world with endless
          <br />
          possibilities and new experiences, and Gutter
          <br />
          Bats Planet is the key to unlocking this world.
          <br />
          <br />
          Gutter Bats Planet is a limited collection of
          <br />
          unique, programatically generated NFTs hosted
          <br />
          on the Ethereum blockchain. Each Gutter Bats
          <br />
          Planet is unique - just like you and
          <br />
          programatically generated from over 140
          <br />
          possible traits, including clothing, eyes, tattoos,
          <br />
          expressions, and more.
          <br />
          <br />
          The initial sale has start in few days. To get your <br />
          Gutter Bats Planet, buy now on OpenSea or mint here.
        </p>
        <a
          href="https://opensea.io/collection/gutter-bats-planet-"
          target="_blank"
          rel="noferrer"
          style={{ all: "unset" }}
        >
          <button id="explore-btn" className="primary-btn">
            Purchase on OpenSea
            <img
              src={opensea}
              style={{
                width: width > 992 ? 30 : 15,
                marginLeft: 10,
                cursor: "pointer",
                filter: "brightness(0.15)",
              }}
            />
          </button>
        </a>
      </div>
    </div>
  );
};

export default Exploring;
